import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Notifications, {notify} from 'react-notify-toast';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';
import swal from 'sweetalert';
import { Table, Button, FormGroup } from 'react-bootstrap';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {bin} from 'react-icons-kit/icomoon/bin';
import SvgIcon from 'react-icons-kit';
import Inputmask from 'inputmask';
import RaisedButton from 'material-ui/RaisedButton';
import { getDateHour, healthFacilitiesUnitRequest, lookups, lookupsType, unitRequest, unitRequestSave, unitRequestUpdate, unitsDistribution } from '../../../libs/services';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';

var Config = require('../../../config');

class OrderUnitsDistribution extends Component{
	constructor(props){
		super(props);

		this.validateInput = this.validateInput.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onSave = this.onSave.bind(this);
		this.onSearchComponent = this.onSearchComponent.bind(this);
		this.searchComponent = this.searchComponent.bind(this);
		this.addComponent = this.addComponent.bind(this);
		this.removeUnitFromList = this.removeUnitFromList.bind(this);
		this.onCancel = this.onCancel.bind(this);
		

		this.state = {
			date_form : "",
			hour: "",
			health_facilities:[],
			requested_by:"",
			requested_to:"",
			messenger:"",
			user:"",
			user_id:"",
			priority:"",
			observations:"",
			priorities:[{id:"0",name:"URGENTE"},{id:"0",name:"24 HORAS"}],
			status:"",

			requestedSelected:[],
			indice:-1,

			requested2Selected:[],
			indice2:-1,

			bloodComponents:[],
			groupRH:[],

			blood_component:"",
			component:"",
			amount:"",
			group_rh:"",

			unitsAdded:[],

			isLoading: false,
			req_by:null,
			req_to:null
		}
	}

	async componentDidMount(){

		if (this.props.match.params.id !== '-1') {
			//editar
			//traer los datos del pedido
			var response = await unitRequest(this.props.match.params.id);
			if(response !== undefined){
				var date = new Date(response.date);

				this.setState({
					requested_by:sessionStorage.getItem('health_facilities_id'),
					requested_to:response.distribuidor,
			      	//observations: response.unit_request.observaciones,
			      	hour:response.hour,
			      	priority:response.priority,
			      	status:response.status,
			      	date_form : date.getFullYear()+'-'+("0" + (date.getMonth() + 1)).slice(-2)+'-'+("0" + date.getDate()).slice(-2),
			    });

			    for (var i = 0; i < response.detail.length; i++) {
			    	var obj = {}
					obj.component_type = response.detail[i].component_type;
					obj.component = response.detail[i].component;
					obj.amount = response.detail[i].amount;
					obj.group_rh = response.detail[i].group +' '+ response.detail[i].rh;
					obj.group = response.detail[i].group;
					obj.rh = response.detail[i].rh;
					obj.observations = response.detail[i].observations;
					
					this.setState({ unitsAdded: [...this.state.unitsAdded, obj]});
			    }
			    this.getHealthFacilities();
			}

		}else {
			this.setState({
				requested_by:sessionStorage.getItem("health_facilities_id"),
			});

			var response = await getDateHour();
			if(response !== undefined){
				var aux = response.split('|');
				
				var hours = this.getHourFormat(aux[1]);
				var aux_date = new Date();

				this.setState({
					date_form : aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
					hour:hours,
				});
			}

			this.getHealthFacilities();
		}

		var selector = document.getElementById("hour");
		var im = new Inputmask("--:--");
		im.mask(selector);

		//obtener usuario
		var user = JSON.parse(sessionStorage.getItem('medical_staff'));

		var name = ""
		if (user.names) {name += user.names};
		if (user.lastname1) {name += ' '+user.lastname1};
		if (user.lastname2) {name += ' '+user.lastname2};

		this.setState({
			user :  name,
			user_id:user.id,
			requested_by:sessionStorage.getItem('health_facilities_id'),
		});		

		this._typeahead_by.getInstance().setState({
			text:sessionStorage.getItem('health_facilities_name')
		});

		response = await lookups('blood_component_type', 'false');
		if(response !== undefined){
			this.setState({
				bloodComponents: response
			});
		}

		response = await lookupsType('blood_group_rh');
		if(response !== undefined){
			this.setState({
				groupRH: response
			});
		}
	}

	//get healt facilities
	async getHealthFacilities(){
		//traer hospitales
		var response = await healthFacilitiesUnitRequest(sessionStorage.getItem('health_facilities_id'));
		if(response !== undefined){
			this.setState({
				health_facilities: response
			});
			
			for (var i = 0; i < response.length; i++) {
				if (response[i].id === parseInt(this.state.requested_by)) {
					this.setState({
						indice:i,
						requestedSelected: [response[i]],
					});
					
				}
				if (response[i].name === this.state.requested_to) {
					this.setState({
						indice2:i,
						requested2Selected: [response[i]],
					});
				}
			}	
		}
	} 

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		var campo = e.target.name;

		this.setState({
			[campo] : e.target.value
		});

		if(campo === 'blood_component'){
			this.setState({
				component_type : e.target.options[e.target.selectedIndex].text
			});
		}

		if(campo === 'hour'){
			var hour = moment(e.target.value, 'h:mm a');

			if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
				document.getElementById(e.target.id).classList.add("error");
				document.getElementById(e.target.name).style.borderColor = "red";
			}else{
				document.getElementById(e.target.name).style.borderColor = "#ccc";
				document.getElementById(e.target.id).classList.remove("error");
			}
		
		}	
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	if(name === 'component'){
        		this.setState({
		            [name]: values[0]
		        });
        	}else{
        		this.setState({
		            [name]: values[0].id
		        });

		        if (name === 'requested_by') {
		        	this.setState({
						indice:0,
						requestedSelected:values,
				    });
		        };

		        if (name === 'requested_to') {
		        	this.setState({
						indice2:0,
						requested2Selected:values,
				    });
		        };
		        document.getElementById('date_form').focus();
        	}
        }
    }

    _handleSearch = (query) => {
	    this.setState({
			indice:-1,
			requestedSelected:[],
	    });
	}

	_handleSearch2 = (query) => {
	    this.setState({
			indice2:-1,
			requested2Selected:[],
	    });
	}

	async onSearchComponent(e){
		if(e.length > 0){
			//llamada busqueda componentes
			var response = await unitsDistribution(e[0].unit_number);
			if(response !== undefined){
				this.setState({
					listComponents: response
				});
			}
		}
	}

	searchComponent(e){
		if(e.key === 'Enter'){
			e.preventDefault();

			setTimeout(()=>{this.addComponent();},500);
		}
	}

	addComponent(){
		var flag = false;

		if (this.state.blood_component !== "" && 
			this.state.amount !== "" &&
			this.state.group_rh !== "") {

			for (var i = 0; i < this.state.unitsAdded.length; i++) {
				if (this.state.unitsAdded[i].component_type === this.state.blood_component &&
					this.state.unitsAdded[i].group_rh === this.state.group_rh) {
					flag = true;
				};
			};

			if (flag === true) {
				swal('¡La unidad no se puede agregar!', '¡Ya se ingreso esa unidad!', 'error');
			} else{
				var obj = {}
				obj.component_type = this.state.blood_component;
				obj.component = this.state.component_type;
				obj.amount = this.state.amount;
				obj.group_rh = this.state.group_rh;
				obj.observations = this.state.observations;

				for (var j = 0; j < this.state.groupRH.length; j++) {

					if (this.state.groupRH[j].name == this.state.group_rh) {
						obj.group = this.state.groupRH[j].key_group;
						obj.rh = this.state.groupRH[j].key_rh;
						break;
					};
				};

				this.setState({ 
					unitsAdded: [...this.state.unitsAdded, obj],
					blood_component:"",
					amount:"",
					group_rh:"",
					observations:""
				});

				document.getElementById('blood_component').focus();
			};	
		} else{
			swal('¡El registro no se puede agregar!', '¡Ingrese componente cantidad y grupo !', 'error');
		};
	}

	validateInput(e) {
	    const re = /^[-+]?$/;
	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);
      		if(form.elements[index + 1] !== undefined){

      			if(form.elements[index + 1].getAttribute("disabled") !== undefined){
    				if(form.elements[index + 1].getAttribute("disabled") === null){
    					form.elements[index + 1].focus();
    				}else if(form.elements[index + 1].getAttribute("disabled") === ""){
    					form.elements[index + 3].focus();
    				}
    			}
      		}
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

  	isValidSearch(){
	    let isFormValid = true;
	    const unit_number = document.getElementById('unit_number');

    	const isInputValid2 = this.showCtrlError(unit_number.name);
      	if (!isInputValid2) {
        	isFormValid = false;
    	}

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	removeUnitFromList = (indice) => {
		
			var array = [...this.state.unitsAdded];
			array.splice(indice, 1);
			this.setState({unitsAdded: array});
		
	}

	async onSave(tipo){
		if(this.isValidDate(this.state.date_form)){
			
			if(this.isValidForm()){
				var object = {};

				object.requested_by = this.state.requested_by;
				object.requested_to = this.state.requested2Selected[0].id;
				object.priority = this.state.priority;

				var date = moment(this.state.date_form.split('-').reverse().join('/'), 'DD-MM-YYYY');
				var hour = moment(this.state.hour, 'h:mm a');

				object.date = date.format('MM-DD-YYYY');;
				object.hour = this.state.hour.indexOf('-') !== -1 ? "Invalid date" : hour.format('HH:mm');

				var temp = [];

				for (var i = 0; i < this.state.unitsAdded.length; i++) {
					var comp = {};
					comp.component_type = this.state.unitsAdded[i].component_type;
					comp.amount = this.state.unitsAdded[i].amount;
					comp.group = this.state.unitsAdded[i].group;
					comp.rh = this.state.unitsAdded[i].rh;
					comp.observations = this.state.unitsAdded[i].observations;

					if (this.props.match.params.id != -1) {
						comp.unit_request_id = this.props.match.params.id;
					};
					
					temp.push(comp);
				};

				object.unit_request_details = temp;
				
				if(object.unit_request_details.length === 0){
					swal('Error', 'Tabla incompleta, debe de ingresar por lo menos un componente sanguíneo', 'error');
				}else{
					//this.waiting_modal.handleShow('Guardando...');

					//validar si es crear o actualizar
					if (this.props.match.params.id != -1) {//actualizar
						object.id = this.props.match.params.id;
						object.status = tipo === 'enviar' ? 'ENVIADO' : 'PENDIENTE'  ;

						var response = await unitRequestUpdate(this.props.match.params.id, object, this.props.waiting);
						if(response !== undefined){
							notify.show("Registro actualizado correctamente.", 'success');

							setTimeout(()=>{
								//this.props.history.push('/distribution');
							}, 1500);

						}
					} else{//crear
						object.status = tipo === 'enviar' ? 'ENVIADO' : 'PENDIENTE';

						var response = await unitRequestSave(object, this.props.waiting);
						if(response !== undefined){
							swal("Correcto", "Registro guardado correctamente.", 'success');
							this.props.history.push('/distribution/orderUnits/'+response.id);
							//this.props.history.push("/distribution");
						}
						
					};
				}
					
			}else{
				swal("¡Error!", "Campos Incompletos", 'error');
			}
		}else{
			notify.show('Error, Fecha no válida','error');
		}
	}

	isValidForm() {
		const inputs = document.querySelectorAll('select,input');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		if(input.id === 'requested_by' || input.id === 'requested_to'){
	    			isFormValid = this.getValidationState(input.id);
	    		}else{
	    			const isInputValid = this.showCtrlError(input.name);
			      	if (!isInputValid) {
			        	isFormValid = false;
			    	}
	    		}
	    		
			      			   
		  	}
	    });
	    
	    return isFormValid;
	}

	isValidDate(fecha){
		var valid = moment(fecha).format('MM-DD-YYYY');

		if(valid === 'Invalid date'){
			return false;
		}else{
			return true;
		}
	}

	getValidationState(name) {
		const length = this.state[name].length;
		let isFormValid = true;
		if (length === 0){
			if(name==='requested_by'){
				this.setState({req_by:'error'});
				isFormValid = false;
			}else{
				this.setState({req_to:'error'});
				isFormValid = false;
			}
		}else{
			if(name==='requested_by'){
				this.setState({req_by:''});
			}else{
				this.setState({req_to:''});
			}
		}

		return isFormValid;

	}

	onCancel(){
		this.props.history.push("/distribution");
	}

	render(){
		const {t} = this.props;

		return(
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.distribution.MAIN')} ->
						{t('sidebar.nav.distribution.orderUnits')}
					</h5>
				</div>
				<form noValidate>
					<div className="col-xs-12">
						{/*<fieldset>
							<legend style={{fontSize:"1.5em", marginBottom:"5px"}}>Búsqueda</legend>
							*/}
							<div className="col-xs-12 col-sm-10" style={{paddingLeft:"0px"}}>
								<div className="col-xs-12 col-sm-3">
									<FormGroup id="req_by" validationState={this.state.req_by} style={{marginBottom:"0px"}}>
										<span className="span-min">Centro Peticionario</span>
										
										<AsyncTypeahead
								          	/*{...this.state}*/
								          	labelKey={(option) => `${option.name}`}
								          	minLength={0}
								          	inputProps={{
								          		name:"requested_by",
								          		required:true,
								          		id:"requested_by",
								          		autoComplete:"off"
								          	}}
								          	id="requested_b"
								          	disabled={true}
								          	options={this.state.health_facilities}
								          	onChange={this.handleTypeAheadChange('requested_by')}
								          	onSearch={this._handleSearch}
								          	defaultSelected={this.state.health_facilities.slice(this.state.indice, 1)}
								          	selected={this.state.requestedSelected}
								          	ref={ref => this._typeahead_by = ref}
								          	useCache={false}
								          	isLoading={this.state.isLoading}
								          	delay={600}
								          	paginationText="Mostrar mas resultados..."
								        />
								    </FormGroup>
								</div>

								<div className="col-xs-12 col-sm-3">
									<FormGroup id="req_to" validationState={this.state.req_to} style={{marginBottom:"0px"}}>
										<span className="span-min">Centro Distribuidor</span>
										<AsyncTypeahead
								          	/*{...this.state}*/
								          	labelKey={(option) => `${option.name}`}
								          	minLength={0}
								          	inputProps={{
								          		name:"requested_to",
								          		required: true,
								          		id:"requested_to"
								          	}}
								          	id="requestedTo"
								          	options={this.state.health_facilities}
								          	onChange={this.handleTypeAheadChange('requested_to')}
								            onSearch={this._handleSearch2}
								          	defaultSelected={this.state.health_facilities.slice(this.state.indice2, 1)}
								          	selected={this.state.requested2Selected}
								          	ref={ref => this._typeahead = ref}
								          	useCache={false}
								          	delay={600}
								          	isLoading={this.state.isLoading}
								          	paginationText="Mostrar mas resultados..."
								        />
								    </FormGroup>
								</div>

								<div className="col-xs-12 col-sm-4" style={{padding:"0px"}}>
									<div className="col-xs-12 col-sm-5">
										<span className="span-min">Fecha Petición</span>
										<input className="form-control" name="date_form" id="date_form" type="date" value={this.state.date_form || ""} 
												onChange={this.handleChange} ref={(input) => { this.inputRef = input }} onKeyPress={(e) => this.validateInput(e)} required />
									</div>
									<div className="col-xs-12 col-sm-3">
										<span className="span-min">Hr Petición</span>
										<input id="hour" name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
												data-inputmask-placeholder="-" value={this.state.hour || ""} onChange={this.handleChange}
												required onKeyPress={(e)=>this.validateInput(e)} className="form-control"/>
									</div>
									<div className="col-xs-12 col-sm-4">
										<span className="span-min">Prioridad</span>
										<select className="form-control" name="priority" id="priority"
											onChange={this.handleChange} value={this.state.priority || ""} onKeyPress={(e) => this.validateInput(e)}>
											<option value="">Seleccione...</option>
											{this.state.priorities.map((type, i) => (
												<option key={i} value={type.name}>{type.name}</option>
											))

											}
										</select>
									</div>
								</div>

								<div className="col-xs-12 col-sm-2" style={{padding:"0px"}}>
									<div className="col-xs-12 col-sm-12">
										<span className="span-min">Usuario Solicita</span>
										<input className="form-control" disabled name="user" id="user" value={ this.state.user } 
											onKeyPress={(e) => this.validateInput(e)}  onChange={ this.handleChange } required/>
									</div>
									
								</div>
							</div>	

							{/*<div className="col-xs-12 ">
								<div className="col-xs-12 col-sm-4">
									<span className="span-min">Observaciones</span>
									<textarea className="form-control" name="observations" value={ this.state.observations } onChange={ this.handleChange } />
								</div>
							</div>*/}

							<fieldset className="col-xs-12 col-sm-10" style={{padding:"0"}}>
								<legend>Unidades</legend>

								<div className="col-xs-12 form-group" style={{padding:"0"}}>
									<div className="col-xs-12 col-sm-2">
										<span className="span-min">Componente Sanguíneo</span>
										
										<select className="form-control" name="blood_component" id="blood_component" 
											onChange={this.handleChange} value={this.state.blood_component || ""} 
											onKeyPress={(e) => this.validateInput(e)}>
											<option value="">Seleccione...</option>
											{this.state.bloodComponents.map((type, i) => (
												<option key={i} value={type.key}>{type.name}</option>
											))

											}
										</select>
									</div>

									<div className="col-xs-12 col-sm-1">
										<span className="span-min">Cantidad</span>
										<input className="form-control" name="amount" id="amount" value={ this.state.amount } 
											onKeyPress={(e) => this.validateInput(e)} onChange={ this.handleChange } />
									</div>

									<div className="col-xs-12 col-sm-1">
										<span className="span-min">Grupo y RH</span>
										
										<select className="form-control" name="group_rh" id="group_rh" 
											onChange={this.handleChange} value={this.state.group_rh || ""} 
											onKeyPress={(e) => this.validateInput(e)}>
											<option value="">Seleccione...</option>
											{this.state.groupRH.map((type, i) => (
												<option key={i} value={type.name}>{type.name}</option>
											))

											}
										</select>
									</div>

									<div className="col-xs-12 col-sm-4">
										<span className="span-min">Observaciones</span>
										<input className="form-control" name="observations" value={ this.state.observations } 
											onChange={ this.handleChange } 
											onKeyPress={(e) => this.validateInput(e)} 
											className={"form-control"}/>
									</div>

									<div className="col-xs-12 col-sm-1">
										<FloatingActionButton className="action-btn" mini={true} style={{marginTop: 15 }} onClick={this.addComponent}>
					                      <ContentAdd/>
					                    </FloatingActionButton> 
									</div>
								</div>

								<div className="col-xs-12"> 
					              <Table responsive hover style={{margin:"0px"}}>
					                <thead>
					                  <tr>
					                    <th>Componente Sanguineo</th>
					                    <th>Cantidad</th>
					                    <th>Grupo y RH</th>
					                    <th>Observaciones</th>
					                    <th width={60}></th>
					                  </tr>
					                </thead>
					                <tbody>
					                 {this.state.unitsAdded.map( (unit, index) => (
					                    <tr key={index}>
					                      <td>{unit.component}</td>
					                      <td>{unit.amount}</td>
					                      <td>{unit.group_rh} </td>
					                      <td>{unit.observations} </td>
					                      <td width={60} style={{textAlign: "center",padding: "2px",}}>
					                        <Button className="btn btn-info btn-xs" title="Eliminar" style={{marginRight:'3px'}} onClick={(e) => this.removeUnitFromList(index, e)}>
					                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
					                        </Button>
					                      </td>
					                    </tr>
					                    ))}
					                </tbody>
					              </Table>
					            </div>
							</fieldset> 

					        <hr style={{width:"100%"}}/>
							<div className="col-xs-9" style={{textAlign:'center'}}>
					        	<div>
					        		<RaisedButton className="action-btn" label={t('content.generics.buttons.submit')} primary={true} onClick={this.onSave.bind(this, 'enviar')}  style={{margin:12}}/>
					        		<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary={true} onClick={this.onSave.bind(this, 'guardar')}  style={{margin:12}}/>
					        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onCancel}/>
					        	</div>
					        </div>
												
						{/*</fieldset>*/}
					</div>
				</form>

				<Notifications />
				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(OrderUnitsDistribution);
